import { Link, useLocation } from 'react-router-dom';
import usePageMeta from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: '页面不存在 - 黑料雷达',
    description: '你访问的页面不存在或已被移动。可以返回首页，或前往事件库检索网站安全事件与隐私风险内容。',
    canonical: '/',
  });

  return (
    <section className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-radar-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-5xl font-black text-background-300 md:text-7xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">没有找到这个页面</h1>
      <p className="mt-3 text-sm leading-7 text-foreground-600">
        你访问的地址 <span className="text-foreground-800">{location.pathname}</span> 不存在或已被移动。
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-600 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/incidents"
          className="whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
        >
          前往事件库
        </Link>
      </div>
    </section>
  );
}